import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterBar } from '../../../../../components/ui/FilterBar';
import { SearchInput } from '../../../../../components/ui/SearchInput';
import { FilterableSelect } from '../../../../../components/ui/FilterableSelect';
import { STATUS_OPTIONS } from '../../../../../features/webhooks/webhooksUtils';
import { setWebhookFilters } from '../../../../../features/webhooks/webhooksSlice';
import { selectWebhookFilters } from '../../../../../features/webhooks/webhooksSelectors';

const STATUS_FILTER_OPTIONS = [{ value: '', label: 'Todos los estados' }, ...STATUS_OPTIONS];

/** Destination URL and status. The listing is filtered in the browser. */
const WebhookFilters = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectWebhookFilters);

  return (
    <FilterBar variant="bare" testId="webhooks-filters">
      <SearchInput
        variant="bare"
        testId="webhooks-search"
        placeholder="Buscar por URL de destino..."
        value={filters.search}
        onChange={(search) => dispatch(setWebhookFilters({ search }))}
      />
      <FilterableSelect
        testId="webhooks-status-filter"
        value={filters.status}
        onChange={(status) => dispatch(setWebhookFilters({ status }))}
        options={STATUS_FILTER_OPTIONS}
        placeholder="Estado"
        searchPlaceholder="Buscar estado..."
      />
    </FilterBar>
  );
};

export default memo(WebhookFilters);
